<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M3.75 3.75h16.5v16.5H3.75zM1.5 20.5h21"/>
</svg>
